import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";

export const Container = ({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        `flex items-center justify-center bg-background w-full ${className}`
      )}
    >
      {children}
    </div>
  );
};

export const TopSection = () => {
  return (
    <div className="flex flex-col items-center lg:gap-[32.46px] gap-[22.84px] w-full">
      <Container className="!h-10" />
      <Link
        href={"/"}
        className="lg:h-[79px] h-[56px] lg:w-[451.15px] w-[317.53px]"
      >
        <Image
          width={451}
          height={79}
          src="/rapidStock-logo.svg"
          alt="rapid-stock logo"
          className="w-full h-full object-contain object-center"
        />
      </Link>
      <Container>
        <h1 className="text-white lg:text-[46px] text-[26px] font-bold max-w-[279.13px] flex flex-col leading-none tracking-[-0.01em] sm:py-[25px] py-[15px]">
          INVENTORY{" "}
          <span className="lg:text-[36px] text-[20px]">MANAGEMENT</span>
        </h1>
      </Container>
    </div>
  );
};
